import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { initSentry } from "./lib/sentry";
import App from "./App";
import "./i18n";
import "./index.css";

// Init Sentry as early as possible — before React mounts — so the SDK
// can hook unhandled rejections and uncaught exceptions during boot.
// No-op when VITE_SENTRY_DSN is not configured.
initSentry();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
